import React from 'react';
import sortedProjects from '../data/projects';

const GithubIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22" />
  </svg>
);

const ArrowIcon = () => (
  <svg width="12" height="12" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="2" y1="7" x2="12" y2="7" />
    <polyline points="8 3 12 7 8 11" />
  </svg>
);

const Projects = () => (
  <section id="projects" className="section">
    <div className="container">
      <p className="section-label">Work</p>
      <h2 className="section-title">Selected Projects</h2>

      <div className="projects-grid">
        {sortedProjects.map((project, index) => {
          const isInProgress = project.status === 'In Progress';

          return (
            <article key={index} className="project-card">
              <div className="project-card-top">
                <div className="project-icon">
                  {project.icon ? project.icon() : null}
                </div>
                <span className={`project-status ${isInProgress ? 'in-progress' : 'completed'}`}>
                  <span className="project-status-dot" />
                  {project.status}
                </span>
              </div>

              <h3 className="project-title">{project.title}</h3>

              {project.description && (
                <p className="project-description">{project.description}</p>
              )}

              {project.githubLink && (
                <a
                  href={project.githubLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-link"
                >
                  <GithubIcon />
                  View on GitHub
                  <ArrowIcon />
                </a>
              )}
            </article>
          );
        })}
      </div>
    </div>
  </section>
);

export default Projects;
